import styled from '@emotion/styled'
import { GroupedParcelList as Base } from 'core/components/GroupedParcelList'
import React, { useState } from 'react'
import { ShippingParcel } from 'stylewhere/api'
import {
  Box,
  ForceParcelByUserPinModal,
  GroupedItemRow,
  GroupedListRow,
  Icons,
  List,
  SmallTagCounter,
} from 'stylewhere/components'
import { T, __ } from 'stylewhere/i18n'
import { SimpleParcelListOperationConfig } from 'stylewhere/shared'

interface Props {
  operation: SimpleParcelListOperationConfig
  parcels: ShippingParcel[]
  loading?: boolean
  removeParcel?: (parcel: ShippingParcel) => void
  refresh?: () => void
}

export function GroupedParcelList({ operation, parcels, removeParcel, loading = false, refresh }: Props) {
  const [forceParcelModal, setForceParcelModal] = useState<ShippingParcel | false>(false)
  const [forcedParcels, setForcedParcels] = useState(() =>
    // Parcel già forzate in precedenza
    parcels.filter(
      ({ attributes }) =>
        attributes.outboundCertificatoForceUserId &&
        attributes.outboundCertificatoForceAuthorisingUserId &&
        attributes.outboundCertificatoForceDate
    )
  )

  if (operation.code !== 'certified-outbound') {
    return <Base operation={operation} parcels={parcels} removeParcel={removeParcel} loading={loading} />
  }

  // Marca le parcel forzate per il render
  parcels.forEach((parcel) => (parcel.__forced = false))
  forcedParcels.forEach((parcel) => {
    parcel.__detected = true
    parcel.__forced = true
  })

  const rowRender = (parcel: ShippingParcel) => {
    let bgColor
    if (parcel.__detected) bgColor = '#75EBA8'
    if (parcel.__forced) bgColor = '#f2ea7d'
    return (
      <GroupedListRow
        onClick={
          refresh
            ? () => {
                if (parcel.__forced) return
                setForceParcelModal(parcel)
                refresh()
              }
            : undefined
        }
        backgroundColor={bgColor}
        pv={16}
        pl={8}
        pr={16}
        style={{ height: 120 }}
      >
        <Box p={8} center>
          <Icons.Rfid width={48} />
        </Box>
        <Box justify="center" pl={8} flex style={{ overflow: 'auto' }}>
          <Code>{parcel.code}</Code>
        </Box>
        <Box row center ml={15}>
          <SmallTagCounter detected={parcel.parcelEntryQuantity} />
        </Box>
      </GroupedListRow>
    )
  }

  if (loading) {
    return (
      <>
        <GroupedItemRow.Skeleton />
        <GroupedItemRow.Skeleton />
      </>
    )
  }

  const rows = parcels.sort((parcel: ShippingParcel) => {
    if (parcel.__unexpected) return -1
    if (parcel.__detected) return 1
    return 0
  })

  return (
    <>
      <List
        data={rows}
        emptyMessage={<span style={{ whiteSpace: 'break-spaces' }}>{__(T.messages.press_start_to_read)}</span>}
        rowRender={rowRender}
      />

      <ForceParcelByUserPinModal
        operationId={operation.id}
        parcel={forceParcelModal}
        onClose={(forcedParcel) => {
          setForceParcelModal(false)
          if (forcedParcel) {
            setForcedParcels([...forcedParcels, forcedParcel])
          }
          refresh?.()
        }}
        visible={!!forceParcelModal}
      />
    </>
  )
}

const Code = styled.div`
  font-weight: bold;
  font-size: 28px;
  white-space: nowrap;
`
